import React, { useState, useEffect, useCallback, useContext } from "react";
import Select from 'react-select';
import { Button } from "@material-ui/core";
import { getAllowedStoresList } from "../services/storeService";
import useShowMessages from "../hooks/useShowMessages";
import useStore from "../hooks/useStore";

const customStyles = {
  control: (styles, {isFocused}) => ({
    ...styles,
    borderBottom: '1px solid #000000',
    backgroundColor:  '#be161d',
    fontSize: '1.2em',
    border: '0',
    borderColor: isFocused ? '1px solid transparent' : 'red',
    boxShadow: isFocused ? '1px solid transparent' : 'red',
    fontSize: 14,
    fontFamily: 'system-ui',
    fontWeight: 700,
    backgroundImage: "linear-gradient(0deg,rgba(0,0,0,.23),transparent 100%,transparent 200%)",
    transition: "box-shadow .3s ease-in-out, background .3s ease-in-out,transform .3s ease-in-out,opacity .3s ease-in-out",
  }),
  placeholder: (styles) => ({
    ...styles, 
    color: "#FFFFFF",
    position: 'static',
    transform: 'none',
  }),
  dropdownIndicator: (styles) => ({
    ...styles, 
    color: "#FFFFFF",
  }),
  input: (styles) => ({
    ...styles, 
    color: "#FFFFFF",
    fontSize: 14,
    fontFamily: 'system-ui',
    fontWeight: 800,
    maxWidth: '150px'
  }),
  singleValue: (styles) => ({
    ...styles, 
    color: "#FFFFFF",
    position: 'static',
    transform: 'none',
    maxWidth: '200px'
  }),
  option: (styles, {isFocused}) => ({
    ...styles,
    color: isFocused ? 'white' : 'black',
    backgroundColor: isFocused ? '#be161d' : 'white',
  }),
  menu: (styles) => ({
    ...styles,
    width: 'fit-content'
  }),
  valueContainer: (styles) => ({
    ...styles,
    minWidth: '100px'
  }),
};

const StoreSwitcher = ({ storeId, isAdmin }) => {
  const { showMessage } = useShowMessages();
  const { setStoreId, selectedStore, setSelectedStoreCallback, setUnfilteredStores, unfilteredStores } = useStore();
  const [storeList, setStoreList] = useState([])

  const setMenuItemList = useCallback ((stores) => {
    const menuStores = stores.filter((item) => item.value != storeId);
    setStoreList(menuStores); 
  }, [storeId]);

  const fetchStores = useCallback( async () => {
    let adminStoreNumber = 1;
    const response = await getAllowedStoresList(adminStoreNumber);
    if(response?.Items && response.Items.filter((item) => item.value == storeId).length === 0 && storeId && storeId != 1){
      showMessage('Store not found.', 'error');
      setStoreId(isAdmin ? 1 : localStorage.getItem('defaultStore'));
    }
    setUnfilteredStores(response?.Items);
    if (response && isAdmin) {
      setMenuItemList(response.Items);
      if(storeId && storeId != 1){
        setSelectedStoreCallback(response.Items.find((item) => item.value == storeId))
      }
    } else if(response && !isAdmin && storeId && storeId != 1) {
      setSelectedStoreCallback(response.Items.find((item) => item.value == storeId))
    }
  }, [isAdmin, setMenuItemList, setUnfilteredStores, setStoreId, storeId, showMessage]);

  useEffect( () => {
    async function fetchData() {
      await fetchStores();
    }
    fetchData();
  }, [fetchStores]);

  useEffect(() => {
    if (unfilteredStores) setMenuItemList(unfilteredStores);
  }, [storeId, setMenuItemList, unfilteredStores]);

  const handleChange = (store) => {
    setStoreId(store.value);
    localStorage.setItem("currentStoreId", store.value)
    setSelectedStoreCallback(store)
  };

  return (
    <div className='store-switcher'>
      {isAdmin ? (
        <Select 
          styles={customStyles}
          unstyled
          placeholder={selectedStore?.label || 'Select Store'}
          onChange={(selected) => handleChange(selected)}
          isSearchable
          options= {storeList}
        >
        </Select> 
        ) : ( selectedStore? 
        ( <Button id="staleButton" disabled >
          {`${selectedStore.label}`}
        </Button>) : ''
          )}
    </div>
  );
};

export default StoreSwitcher;
